import classNames from 'classnames';
import React from 'react';
import { STATUS_COLORS } from 'src/lib/shipment-statuses';
import { Badge } from 'straightline-ui';
import { OFFER_STATUS } from 'straightline-utils/constants';

export const StatusBadge = ({ status, className, children, ...rest }) => {
  return (
    <Badge
      className={classNames(
        className,
        `badge-soft-${STATUS_COLORS[status.value]}`
      )}
      style={{ padding: 8.5, fontSize: '95%' }}
      {...rest}
    >
      {children}
      {status.label}
    </Badge>
  );
};

export const offerStatusColors = {
  [OFFER_STATUS.PENDING]: 'soft-warning',
  [OFFER_STATUS.COUNTERED]: 'soft-info',
  [OFFER_STATUS.ACCEPTED]: 'soft-success',
  [OFFER_STATUS.REJECTED]: 'soft-danger'
};

export const offerStatusTexts = {
  [OFFER_STATUS.PENDING]:
    'Straightline is reviewing your offer and will notify you soon. You can also make another offer.',
  [OFFER_STATUS.COUNTERED]:
    'Straightline has countered your offer. Click the button to review the details and book this load.',
  [OFFER_STATUS.ACCEPTED]:
    'Your offer has been accepted! Click the button to review the terms and book this load.',
  [OFFER_STATUS.REJECTED]:
    'This offer was rejected. Try making another offer with a lower price. Straightline will then review your new price and notify you.'
};

export const offerStatusLabels = {
  [OFFER_STATUS.PENDING]: 'Pending',
  [OFFER_STATUS.COUNTERED]: 'Countered',
  [OFFER_STATUS.ACCEPTED]: 'Accepted',
  [OFFER_STATUS.REJECTED]: 'Rejected'
};

export const OfferStatusBadge = ({ status }) => {
  return (
    <Badge color={offerStatusColors[status]}>{offerStatusLabels[status]}</Badge>
  );
};
